import React, { useState } from 'react';
import Hero from '../../components/ui/Hero';
import SubmissionForm from '../../components/submission/SubmissionForm';
import { useAuth } from '../../hooks/useAuth';
import { Lock } from 'lucide-react';

const EditMediaPage = () => {
  const { user, signIn } = useAuth();
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp";

  if (!user) {
    return (
      <div>
        <Hero
          title="Edit Animatronic Media"
          description="Help improve our database by updating animatronic media"
          backgroundImage={heroImage}
          compact
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <Lock className="w-12 h-12 text-brand mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-4">Sign In Required</h2>
            <p className="text-content-secondary mb-6">
              You need to be signed in to edit animatronic media.
            </p>
            <button
              onClick={signIn}
              className="btn-primary"
            >
              Sign In to Contribute
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Hero
        title="Edit Animatronic Media"
        description="Help improve our database by updating animatronic media"
        backgroundImage={heroImage}
        compact
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="card p-6">
          <SubmissionForm mode="edit" />
        </div>
      </div>
    </div>
  );
};

export default EditMediaPage;